// extracted by mini-css-extract-plugin
export default {"dob_edit":"educater_dob_edit__T-nms","gender_contain":"educater_gender_contain__A6E2a"};